// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwSplmTable from 'viewmodel/AwSplmTableViewModel';
    

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/DesListLibraryContentService', () => import('js/DesListLibraryContentService'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "lifecycleHooks": {
        "onUpdate": [
            {
                "action": "revealBatchJob",
                "observers": [
                    "props.librarycomponentid",
                    "props.libraryurn"
                ]
            }
        ]
    },
    "data": {
        "loadColumn": [
            {
                "name": "revisionId",
                "displayName": "{{i18n.revisionId}}",
                "maxWidth": 100,
                "minWidth": 60,
                "width": 90,
                "enableColumnMenu": false,
                "enableColumnHiding": false,
                "pinnedLeft": true
            },
            {
                "name": "name",
                "displayName": "{{i18n.name}}",
                "maxWidth": 280,
                "minWidth": 180,
                "width": 180,
                "enableColumnMenu": false,
                "enableColumnHiding": false,
                "pinnedLeft": true
            },
            {
                "name": "minVersion",
                "displayName": "{{i18n.minVersion}}",
                "maxWidth": 180,
                "minWidth": 60,
                "width": 100,
                "enableColumnMenu": false,
                "enableColumnHiding": false,
                "pinnedLeft": true
            },
            {
                "name": "maxVersion",
                "displayName": "{{i18n.maxVersion}}",
                "maxWidth": 180,
                "minWidth": 60,
                "width": 100,
                "enableColumnMenu": false,
                "enableColumnHiding": false,
                "pinnedLeft": true
            },
            {
                "name": "createdBy",
                "displayName": "{{i18n.createdBy}}",
                "maxWidth": 180,
                "minWidth": 130,
                "width": 160,
                "enableColumnMenu": false,
                "enableColumnHiding": false,
                "pinnedLeft": true
            },
            {
                "name": "dateModified",
                "displayName": "{{i18n.dateModified}}",
                "maxWidth": 180,
                "minWidth": 160,
                "width": 130,
                "enableColumnMenu": false,
                "enableColumnHiding": false,
                "pinnedLeft": true
            },
            {
                "name": "status",
                "displayName": "{{i18n.status}}",
                "maxWidth": 180,
                "minWidth": 60,
                "width": 110,
                "enableColumnMenu": false,
                "enableColumnHiding": false,
                "pinnedLeft": true
            },
            {
                "name": "attachments",
                "displayName": "{{i18n.attachmentsOfComponent}}",
                "maxWidth": 280,
                "minWidth": 180,
                "width": 210,
                "enableColumnMenu": false,
                "enableColumnHiding": false,
                "pinnedLeft": true
            }
        ],
        "skip": 0,
        "limit": 15
    },
    "props": {
        "accsessionid": {
            "type": "STRING"
        },
        "librarycomponentid": {
            "type": "STRING"
        },
        "libraryurn": {
            "type": "STRING"
        },
        "locale": {
            "type": "STRING"
        }
    },
    "dataProviders": {
        "libraryComponentRevisionsTableRowProvider": {
            "action": "getRevisionsOfLibraryComponent",
            "response": "{{data.libraryComponentRevisions}}",
            "totalFound": "{{data.totalFound}}",
            "selectionModelMode": "single"
        }
    },
    "columnProviders": {
        "libraryComponentRevisionsTableColumnProvider": {
            "frozenColumnIndex": -1,
            "columns": "{{data.loadColumn}}"
        }
    },
    "grids": {
        "libraryComponentRevisionsTable": {
            "dataProvider": "libraryComponentRevisionsTableRowProvider",
            "columnProvider": "libraryComponentRevisionsTableColumnProvider",
            "addIconColumn": false,
            "gridOptions": {
                "enablePinning": true,
                "enableSorting": false,
                "enableDynamicRowHeight": true
            }
        }
    },
    "actions": {
        "getRevisionsOfLibraryComponent": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": false,
                    "data": {
                        "additionalProperties": {},
                        "appBaseUrl": "session",
                        "query": "query performSearchForRevisions( $performSearchForRevisionsInput: PerformSearchForRevisionsInput) { performSearchForRevisions( performSearchForRevisionsInput: $performSearchForRevisionsInput ) }",
                        "variables": {
                            "performSearchForRevisionsInput": {
                                "libraryUrn": "{{props.libraryurn}}",
                                "componentId": "{{props.librarycomponentid}}",
                                "limit": "{{data.limit}}",
                                "skip": "{{data.skip}}"
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accsessionid": "{{props.accsessionid}}"
            },
            "outputData": {
                "libraryComponentRevisions": "data.data.performSearchForRevisions.output.data",
                "totalFound": "data.data.performSearchForRevisions.output.totalFound",
                "skip": "data.data.performSearchForRevisions.output.skip"
            },
            "events": {
                "success": [
                    {
                        "name": "getRevisionsOfLibraryComponent.success",
                        "eventData": {
                            "catalogLogs": "{{data.output.data}}"
                        },
                        "condition": "output.success == true"
                    }
                ],
                "failure": [
                    {
                        "name": "getRevisionsOfLibraryComponent.failure",
                        "eventData": {
                            "catalogLogs": "{{data.output}}"
                        },
                        "condition": "output.success == false"
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "reveal": {
            "actionType": "dataProvider",
            "method": "libraryComponentRevisionsTableRowProvider"
        },
        "resetSkipValue": {
            "actionType": "JSFunction",
            "method": "resetSkipValue",
            "inputData": {
                "vmo": "{{data}}"
            },
            "deps": "js/DesListLibraryContentService"
        },
        "revealBatchJob": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "resetSkipValue"
                },
                {
                    "action": "reveal"
                }
            ]
        }
    },
    "onEvent": [],
    "conditions": {},
    "i18n": {
        "name": [
            "DesLibraryMessages"
        ],
        "minVersion": [
            "DesLibraryMessages"
        ],
        "maxVersion": [
            "DesLibraryMessages"
        ],
        "createdBy": [
            "DesLibraryMessages"
        ],
        "dateModified": [
            "DesLibraryMessages"
        ],
        "status": [
            "DesLibraryMessages"
        ],
        "attachmentsOfComponent": [
            "DesLibraryMessages"
        ],
        "revisionId": [
            "DesLibraryMessages"
        ]
    },
    "_viewModelId": "DesLibraryComponentRevisions",
    "_uniqueViewModelId": "DesLibraryComponentRevisions",
    "ctx": {}
};

    /*
    <aw-splm-table gridid="libraryComponentRevisionsTable"></aw-splm-table>
    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <AwSplmTable {...grids.libraryComponentRevisionsTable}>
    </AwSplmTable>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;